const state = {
  modal: false
}

const actions = {

}

const getters = {
  getModal (state) {
    return state.modal
  }
}

const mutations = {
  setModal (state, modal) {
    state.modal = modal
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
